module.exports = __webpack_public_path__ + "assets/fonts/Roboto-Thin.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/roboto/Roboto-Thin.woff
// module id = 691
// module chunks = 0